import { UserLayout } from "@/src/layouts/UserLayout";
import { Card } from "@/src/components";
import { VoteCard, VoteBalance, VoteButtons } from "@/src/views/home";

export const Vote = () => {
  return (
    <UserLayout>
      <div className="max-w-5xl w-full mx-auto p-4 sm:p-5 lg:p-8 space-y-6">
        <h1 className="text-2xl font-bold text-foreground">Supply Vote</h1>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <div className="lg:col-span-2">
            <Card className="h-full">
              <VoteCard />
            </Card>
          </div>
          <div className="space-y-4">
            <VoteBalance />
            <VoteButtons />
          </div>
        </div>
      </div>
    </UserLayout>
  );
};
